import { useMutation } from '@tanstack/react-query'

import { UsersService } from '../lib/users.service'
import { UserAgreementsPayload } from '../lib/users.types'

export const SAVE_AGREEMENTS_MUTATION_KEY = 'save-agreements'

export const useSaveAgreements = () => {
  return useMutation({
    mutationKey: [SAVE_AGREEMENTS_MUTATION_KEY],
    mutationFn: (payload: UserAgreementsPayload) =>
      UsersService.saveAgreements(payload)
  })
}
